import { type ReactNode } from 'react'
import { useNls } from '../../../nls/nlsProvider'
import './ownerKit.css'

export type OwnerCardProps = {
  title: string
  metaLine?: string
  onMenuClick?: () => void
  children: ReactNode
  primaryAction?: ReactNode
  secondaryAction?: ReactNode
  metaChips?: ReactNode[]
  className?: string
  maxBodyHeight?: number | string
}

export function OwnerCard({
  title,
  metaLine,
  onMenuClick,
  children,
  primaryAction,
  secondaryAction,
  metaChips,
  className = '',
  maxBodyHeight = 380,
}: OwnerCardProps) {
  const { t } = useNls()

  return (
    <section className={`ownerCard ${className}`} data-testid="owner-card">
      <div className="ownerCardHeader">
        <div className="ownerCardTitleArea">
          <h3 className="ownerCardTitle">{title}</h3>
          {metaLine && <p className="ownerCardMetaLine">{metaLine}</p>}
        </div>
        {onMenuClick && (
          <button
            type="button"
            className="ownerCardMenuBtn"
            onClick={onMenuClick}
            aria-label={t('NLSOwnerConsoleCardOptions')}
          >
            ⋯
          </button>
        )}
      </div>

      <div className="ownerCardBody" style={{ maxHeight: maxBodyHeight }}>
        {children}
      </div>

      {(primaryAction || secondaryAction || (metaChips && metaChips.length > 0)) && (
        <div className="ownerCardActions">
          <div className="ownerCardActionsLeft">
            {primaryAction}
            {secondaryAction}
          </div>
          {metaChips && metaChips.length > 0 && (
            <div className="ownerCardActionsRight">
              {metaChips.map((chip, i) => (
                <span key={i} className="ownerCardMetaChip">
                  {chip}
                </span>
              ))}
            </div>
          )}
        </div>
      )}
    </section>
  )
}
